import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import {FinaBranch} from '@app/services/api/e-invoice-api.service';

export interface FinaBranchSelectionDialogData {
  recipientName?: string;
  recipientOib?: string;
  branches: FinaBranch[];
  preferredBranchPartyId?: string;
  mode: 'recipient' | 'sender'; // 'recipient' for existing flow, 'sender' for new sender branch selection
  context?: 'settings' | 'invoice-creation'; // Optional context for sender mode
}

@Component({
    selector: 'app-fina-branch-selection-dialog',
    templateUrl: './fina-branch-selection-dialog.component.html',
    styleUrls: ['./fina-branch-selection-dialog.component.scss'],
    standalone: false
})
export class FinaBranchSelectionDialogComponent implements OnInit {
    selectedBranch: FinaBranch | null = null;

    constructor(@Inject(MAT_DIALOG_DATA) public data: FinaBranchSelectionDialogData,
                public dialogRef: MatDialogRef<FinaBranchSelectionDialogComponent>) {
    }

    static open(dialog: MatDialog, data: FinaBranchSelectionDialogData) {
        return dialog.open(FinaBranchSelectionDialogComponent, {
            width: '600px',
            disableClose: data.mode === 'sender' && data.context === 'invoice-creation', // Only disableClose for sender in invoice creation
            data: data
        });
    }

    /**
     * Helper method to determine if party_id represents a main branch or sub-branch
     */
    getBranchType(partyId: string): 'main' | 'sub' {
        return partyId.includes('::') ? 'sub' : 'main';
    }

    /**
     * Extract branch code from party_id (for sub-branches)
     * Returns the part after :: (e.g., "HR99:11484")
     */
    getBranchCode(partyId: string): string | null {
        if (!partyId.includes('::')) return null;
        const [, branchCode] = partyId.split('::');
        return branchCode;
    }

    ngOnInit() {
        // Pre-select preferred branch if available
        if (this.data.preferredBranchPartyId) {
            this.selectedBranch = this.data.branches.find(
                b => b.party_id === this.data.preferredBranchPartyId
            ) || null;
        }

        // If no preferred branch or not found, select the first branch
        if (!this.selectedBranch && this.data.branches.length > 0) {
            this.selectedBranch = this.data.branches[0];
        }
    }

    selectBranch(branch: FinaBranch) {
        this.selectedBranch = branch;
    }

    cancel() {
        this.dialogRef.close(null);
    }

    confirm() {
        this.dialogRef.close(this.selectedBranch);
    }

    isSelected(branch: FinaBranch): boolean {
        return this.selectedBranch?.party_id === branch.party_id;
    }
}
